import postal from 'postal';
import React from 'react';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';
import { CreditCardEntry } from '../funnel/credit_card_entry';

const createReactClass = require('create-react-class');

const PurchaseGiftForm = createReactClass({
  getInitialState() {
    return {
      submitInProgress: false,
      generalSubmitError: false,
      couponsPurchased: this.props.couponsPurchased,
      showCreditCardFields: this.props.showCreditCardFields,
      errors: {}
    };
  },
  componentWillMount() {
    const messagingChannelName = 'gift_messagingChannel';
    this.messagingChannel = postal.channel(messagingChannelName);
  },
  componentDidMount() {
    if (this.props.showCreditCardFields) {
      $('.visual').addClass('extended');
    }
  },
  preSubmitCardErrors() {
    const { errors } = this.state;
    if (this.state.showCreditCardFields) {
      if (
        $('#user_first_name')
          .val()
          .trim() === ''
      ) {
        errors.first_name = [StringConstantsMixin.strings.REQUIRED];
      }
      if (
        $('#user_last_name')
          .val()
          .trim() === ''
      ) {
        errors.last_name = [StringConstantsMixin.strings.REQUIRED];
      }
      const ccErrors = this.pro_input_fields.preSubmitErrors();

      Object.assign(errors, ccErrors);
      this.setState({ errors });
    }

    if (Object.keys(errors).length > 0) {
      return true;
    }
    return false;
  },
  handlePurchaseClick() {
    // catch multiple clicks
    if (this.state.submitInProgress) return;

    if (this.preSubmitCardErrors()) {
      return;
    }

    const url = '/api/alltrails/gift';
    this.setState({ submitInProgress: true, generalSubmitError: false });

    let data = {};
    if (this.state.showCreditCardFields) {
      // treat like a form submission
      data = {
        first_name: $('#user_first_name').val(),
        last_name: $('#user_last_name').val(),
        cc_number: $('#user_cc_number').val(),
        cc_csc: $('#user_cc_csc').val(),
        cc_expiration_month: $('#user_cc_expiration_month').val(),
        cc_expiration_year: $('#user_cc_expiration_year').val(),
        payment_currency: this.props.payment_currency,
        zip: $('#user_zip').val()
      };
    }

    if (this.props.giftPriceCouponCode) data.code = this.props.giftPriceCouponCode;

    $.ajax({
      url,
      type: 'POST',
      headers: {
        'X-AT-KEY': ServerCommunicationUtil.apiKey
      },
      data,
      success: data => {
        const coupon = data.coupons[0];
        this.messagingChannel.publish({
          topic: 'newCoupon.gifted',
          data: {
            coupon
          }
        });
        this.setState(
          {
            latestCoupon: coupon,
            submitInProgress: false,
            errors: {},
            couponsPurchased: this.state.couponsPurchased + 1,
            showCreditCardFields: false
          },
          () => {
            $('.visual').removeClass('extended');
          }
        );
      },
      error: err => {
        if (this.state.showCreditCardFields) {
          const parsed = JSON.parse(err.responseText);

          let currentErrors = this.state.errors;
          if (parsed && parsed.errors) {
            currentErrors = parsed.errors;
          }
          this.setState({ errors: currentErrors, submitInProgress: false });
        } else {
          // show generic error if we are not showing credit card fields
          this.setState({ generalSubmitError: true });
        }
      }
    });
  },

  // Code extracted from ProMixin (will be refactored very soon with new Gifting flows)
  preSubmitErrors() {
    const { errors } = this.state;
    const ccErrors = this.pro_input_fields.preSubmitErrors();
    let signupErrors = [];

    if (this.props.showProSignupElements == true) {
      signupErrors = this.signup_input_fields.preSubmitErrors();
    }
    if (this.state.firstName.trim() == '') {
      errors.first_name = ['Required'];
    }
    if (this.state.lastName.trim() == '') {
      errors.last_name = ['Required'];
    }

    Object.assign(errors, ccErrors);
    this.setState({ errors });

    if (Object.keys(errors).length > 0 || signupErrors.length > 0) {
      return true;
    }
    return false;
  },
  clearStateErrors(errors) {
    if (errors.length > 0 && Object.keys(this.state.errors).length > 0) {
      const errorObj = this.state.errors;
      for (let i = 0; i < errors.length; i++) {
        delete errorObj[errors[i]];
      }
      this.setState({ errors: errorObj });
    }
  },
  checkIfRemoveStateErrors() {
    const errorsToRemove = [];
    if (this.state.firstName) errorsToRemove.push('first_name');

    if (this.state.lastName) {
      errorsToRemove.push('last_name');
    }

    this.clearStateErrors(errorsToRemove);
  },
  handleFirstNameTextChange(event) {
    const newVal = event.target.value;
    this.setState({ firstName: newVal }, this.checkIfRemoveStateErrors);
  },
  handleFirstNameTextBlur(event) {
    const newVal = event.target.value;
    this.setState({ firstName: newVal }, this.checkIfRemoveStateErrors);
  },
  handleLastNameTextChange(event) {
    const newVal = event.target.value;
    this.setState({ lastName: newVal }, this.checkIfRemoveStateErrors);
  },
  handleLastNameTextBlur(event) {
    const newVal = event.target.value;
    this.setState({ lastName: newVal }, this.checkIfRemoveStateErrors);
  },
  firstNameDiv() {
    let holderClasses = 'holder';
    let divClasses = 'input string required';
    let errorMessage = '';
    let billingFirstName;
    if (this.props.paramsUser) {
      if (this.props.paramsUser.first_name) {
        billingFirstName = this.props.paramsUser.first_name;
      } else if (this.props.paramsUser.billing_first_name) {
        billingFirstName = this.props.paramsUser.billing_first_name;
      }
    } else if (this.props.user && this.props.user.user) {
      billingFirstName = this.props.user.user.first_name;
    }
    if (Object(this.state.errors).hasOwnProperty('first_name')) {
      divClasses += ' field_with_errors';
      holderClasses += ' field_with_errors';
      errorMessage = <span className="error">{this.state.errors.first_name[0]}</span>;
    }
    return (
      <div className={holderClasses}>
        <div className={divClasses}>
          <input
            className="string required text"
            id="user_first_name"
            maxLength="40"
            name="user[first_name]"
            placeholder={StringConstantsMixin.strings.SIGNUP.FIRST_NAME}
            defaultValue={billingFirstName}
            required="required"
            size="40"
            type="text"
            onChange={this.handleFirstNameTextChange}
            onBlur={this.handleFirstNameTextBlur}
          />
          {errorMessage}
        </div>
      </div>
    );
  },
  lastNameDiv() {
    let holderClasses = 'holder';
    let divClasses = 'input string required';
    let errorMessage = '';
    let billingLastName;
    if (this.props.paramsUser) {
      if (this.props.paramsUser.last_name) {
        billingLastName = this.props.paramsUser.last_name;
      } else if (this.props.paramsUser.billing_last_name) {
        billingLastName = this.props.paramsUser.billing_last_name;
      }
    } else if (this.props.user && this.props.user.user) {
      billingLastName = this.props.user.user.last_name;
    }

    if (Object(this.state.errors).hasOwnProperty('last_name')) {
      divClasses += ' field_with_errors';
      holderClasses += ' field_with_errors';
      errorMessage = <span className="error">{this.state.errors.last_name[0]}</span>;
    }
    return (
      <div className={holderClasses}>
        <div className={divClasses}>
          <input
            className="string required text"
            id="user_last_name"
            maxLength="40"
            name="user[last_name]"
            placeholder={StringConstantsMixin.strings.SIGNUP.LAST_NAME}
            defaultValue={billingLastName}
            required="required"
            size="40"
            type="text"
            onChange={this.handleLastNameTextChange}
            onBlur={this.handleLastNameTextBlur}
          />
          {errorMessage}
        </div>
      </div>
    );
  },

  render() {
    if (this.state.generalSubmitError) {
      if (this.props.selfServiceLink) {
        return <div className="gift-error">{StringConstantsMixin.strings.COUPON.ERROR_PROCESSING}</div>;
      }
      return <div className="gift-error">{StringConstantsMixin.strings.ERR_TRY_AGAIN}</div>;
    }

    let errorSpan = '';
    if (this.state.errors.base) {
      errorSpan = <span className="error-base allow-wrap">{this.state.errors.base[0]}</span>;
    }

    let cardInputsDiv;
    if (this.state.showCreditCardFields) {
      const firstNameDiv = this.firstNameDiv();
      const lastNameDiv = this.lastNameDiv();
      cardInputsDiv = (
        <div className="content form-content clearfix">
          {firstNameDiv}
          {lastNameDiv}
          <CreditCardEntry
            recurlyPublicKey={this.props.recurlyPublicKey}
            errors={this.state.errors}
            user={this.props.user}
            paramsUser={this.props.paramsUser}
            clearStateErrors={this.clearStateErrors}
            ref={instance => {
              this.pro_input_fields = instance;
            }}
          />
        </div>
      );
    }

    let cardChargeText = `1. ${StringConstantsMixin.strings.COUPON.CARD_CHARGE_NORMAL.replace('{fullPrice}', this.props.fullPrice)}`;
    if (this.props.isDiscounted) {
      cardChargeText = `1. ${StringConstantsMixin.strings.COUPON.CARD_CHARGE_DISCOUNT.replace('{giftPrice}', this.props.giftPrice).replace(
        '{fullPrice}',
        this.props.fullPrice
      )}`;
    }

    let couponPurchaseText = StringConstantsMixin.strings.COUPON.BUY_GIFT;
    if (this.state.submitInProgress) {
      couponPurchaseText = StringConstantsMixin.strings.SIGNUP.PLEASE_WAIT;
    } else if (this.state.couponsPurchased > 0) couponPurchaseText = StringConstantsMixin.strings.COUPON.BUY_AGAIN;
    return (
      <div>
        {errorSpan}
        {cardInputsDiv}
        <div id="gift-instructions" className={StringConstantsMixin.constants.XLATE.NONE}>
          <p>1. {StringConstantsMixin.strings.COUPON.GIFT_INSTRUCTIONS}</p>
          <br />
          <p>{cardChargeText}</p>
          <br />
          <p>2. {StringConstantsMixin.strings.COUPON.GIFT_POST_BUY}</p>
          <br />
          <p>3. {StringConstantsMixin.strings.COUPON.GIFT_SHARE}</p>
        </div>
        <div id="purchase-bar">
          <div className={`new-btn upgrade bar-button ${StringConstantsMixin.constants.XLATE.NONE}`} onClick={this.handlePurchaseClick}>
            {couponPurchaseText}
          </div>
        </div>
      </div>
    );
  }
});

export { PurchaseGiftForm };
